var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { StudyStatus } from "healthex-common/study.dtos";
export class ResearcherStudiesDetailViewModel {
    constructor(container) {
        this.studiesUIManager = container.studiesUIManager;
    }
    get study() {
        const study = this.studiesUIManager.studyToManage;
        if (study === NOT_LOADED) {
            return NOT_LOADED;
        }
        if (!study) {
            return null;
        }
        return study;
    }
    get isProjectCompletedOrWithdrawn() {
        if (this.study === NOT_LOADED || this.study === null)
            return false;
        return [StudyStatus.COMPLETED, StudyStatus.WITHDRAWN].includes(this.study.status);
    }
    get showEditProjectButton() {
        return !this.isProjectCompletedOrWithdrawn;
    }
    async editProject() {
        await this.studiesUIManager.editProject();
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], ResearcherStudiesDetailViewModel.prototype, "study", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], ResearcherStudiesDetailViewModel.prototype, "isProjectCompletedOrWithdrawn", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], ResearcherStudiesDetailViewModel.prototype, "showEditProjectButton", null);
